import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { ISplitItemInitialState } from "./splitItemModel";
import {
  findAllOrderLabelSplit,
  getDataByUniqueProductID,
  insertOrderLabelSplit,
  findByIDOrderLabelSplit,
} from "./services/splitItem.services";

const initialState: ISplitItemInitialState = {
  loading: false,
  error: "",
  labelSplitDropdownList: [],
  mainLabelData: null,
  currentSplitList: [],
};

const splitItemSlice = createSlice({
  name: "splitItem",
  initialState,
  reducers: {
    clearSplitItemState: (state) => {
      state.mainLabelData = null;
      state.currentSplitList = [];
    },
    setSplitList: (state, action: PayloadAction<any[]>) => {
      state.currentSplitList = action.payload;
    },
  },
  extraReducers: (builder) => {
    // Find All Order Label Split
    builder.addCase(findAllOrderLabelSplit.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(findAllOrderLabelSplit.fulfilled, (state, action) => {
      state.loading = false;
      state.labelSplitDropdownList = action.payload;
    });
    builder.addCase(findAllOrderLabelSplit.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // Get Data By Unique Product ID
    builder.addCase(getDataByUniqueProductID.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getDataByUniqueProductID.fulfilled, (state, action) => {
      state.loading = false;
      state.mainLabelData = action.payload;
      state.currentSplitList = []; // Reset splits when main item changes
    });
    builder.addCase(getDataByUniqueProductID.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.mainLabelData = null;
    });

    // Insert Order Label Split
    builder.addCase(insertOrderLabelSplit.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(insertOrderLabelSplit.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(insertOrderLabelSplit.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // Find By ID Order Label Split
    builder.addCase(findByIDOrderLabelSplit.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(findByIDOrderLabelSplit.fulfilled, (state, action) => {
      state.loading = false;
      state.mainLabelData = action.payload;
    });
    builder.addCase(findByIDOrderLabelSplit.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearSplitItemState, setSplitList } = splitItemSlice.actions;

export default splitItemSlice.reducer;
